// extracted by mini-css-extract-plugin
export default {"container":"g0i-8","tab":"nt9kG","active":"P5GHV","img":"--5dw","label":"Z7BJw"};